import { LinearProgress } from "@mui/material";
import Drawer from "../../../components/ui/Drawer";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton, cls } from "../../hatim/soft/SoftKit";
import useMemberGoalEditor from "../../goals/useMemberGoalEditor";
import GoalListRow from "../../goals/GoalListRow";

/**
 * Bir grup üyesinin grup hedeflerini düzenleme paneli.
 * Yalnızca grup hedefleri (isCustom === false) gösterilir; kişisel hedefler
 * kullanıcının kendisine aittir, yönetici bunlara dokunamaz. Ekleme ve
 * düzenleme takip ayarlı hedef sihirbazıyla, üstte açılan çekmecede.
 */
export default function EditUserGoalsDrawer({ open, groupId, member, refreshing, onClose }) {
  const { t } = useScriptMode();
  const editor = useMemberGoalEditor({ groupId, member, refreshing });
  const initials = ((member?.name || "?")[0] + ((member?.surname || "")[0] || "")).toUpperCase();

  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        title={editor.targetName || t("manage_goals_modal_title").replace(/\{name\}/g, "")}
        subtitle={member?.email || t("groups_goals_drawer_subtitle")}
        titleIcon={<span className="text-sm font-Bold">{initials}</span>}
        footer={
          <div className="flex gap-2">
            <SoftButton tone="soft" fullWidth onClick={onClose}>
              {t("manage_goals_close")}
            </SoftButton>
            <SoftButton tone="primary" fullWidth onClick={editor.openAdd} disabled={editor.busy}>
              {t("manage_goals_add_cta")}
            </SoftButton>
          </div>
        }
      >
        {editor.busy && (
          <LinearProgress
            className="!h-1"
            sx={{
              backgroundColor: "#D6EBEB",
              "& .MuiLinearProgress-bar": { backgroundColor: "#006A71" },
            }}
          />
        )}
        <h3 className={`px-4 pt-4 pb-2 text-sm ${cls.muted}`}>{t("manage_section_group_goals")}</h3>
        {editor.goals.length === 0 ? (
          <p className={`px-4 text-sm ${cls.muted}`}>{t("manage_goals_empty")}</p>
        ) : (
          <ul>
            {editor.goals.map((goal) => (
              <GoalListRow
                key={`${goal.label}::${goal.activity || "okuma"}`}
                goal={goal}
                busy={editor.busy}
                onEdit={() => editor.openEdit(goal)}
                onDelete={() => editor.askDelete(goal)}
              />
            ))}
          </ul>
        )}
      </Drawer>
      {editor.elements}
    </>
  );
}
